import {NgModule} from '@angular/core';
import {AppCardExamComponent} from './card-exam.component';
import {AppCardSideLineModule} from '@component/card/card-side-line/card-side-line.module';
import {AppCardModule} from '@component/card/card.module';
import {SharedModule} from '@shared/shared.module';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SecurityModule} from '@core/security/security.module';

@NgModule({
    declarations: [
        AppCardExamComponent,
    ],
    imports: [
        AppCardModule,
        AppCardSideLineModule,
        SharedModule,
        FormsModule,
        CommonModule,
        SecurityModule,
    ],
    exports: [
        AppCardExamComponent,
    ],
})
export class CardExamModule {}
